import {
    helperGetCookie,
    helperSetCookie,
    helperSetCookieExpirationDate,
} from "../functions/cookiesHelpers";

export default class LangModal {
    constructor() {
        this.modal = document.querySelector(".jsLangModal");
        this.closeLangModalBtn = document.querySelector(".jsCloseLangModal");

        this.langLink = document.querySelectorAll(".apw-lang-item");

        this.dropdown = document.querySelector(".customSwitcherJs");
        this.dropdownModal = document.querySelector(".customSwitcherModalJs");

        this.language = navigator.languages
            ? navigator.languages[0]
            : navigator.language || navigator.userLanguage;

        if (this.language.includes("-")) {
            this.language = this.language.substring(
                0,
                this.language.indexOf("-")
            );
        }

        this.events();
    }

    events() {
        // this.getLangs();

        if (this.dropdown) {
            this.dropdownClick();
        }

        if (this.dropdownModal) {
            this.dropdownModalClick();
        }

        this.langLink.forEach((el) =>
            el.addEventListener("click", (e) => {
                this.langLinkClick(e);
            })
        );

        this.closeLangModalBtn.addEventListener("click", (e) => {
            this.closeModalLang();
        });
    }

    getLangs() {
        let browserLang = helperGetCookie("ig_browser_lang");
        const userLang = helperGetCookie("ig_user_lang");

        // Get browser lang
        if (browserLang === undefined) {
            helperSetCookie("ig_browser_lang", this.language, {
                expires: helperSetCookieExpirationDate(30),
            });

            browserLang = helperGetCookie("ig_browser_lang");
        }

        // Get default lang
        if (userLang === undefined) {
            // Get current lang if cookie not exist
            this.getCurrentLang().then((resp) => {
                const getCurrentLang = resp;

                // Compare current lang with browser lang
                if (browserLang === getCurrentLang) {
                    // console.log("the same!");
                } else {
                    this.modal.classList.remove("is-hidden");
                    document.body.classList.add("show-lang-modal");
                }
            });

            helperSetCookie("ig_user_lang", this.language, {
                expires: helperSetCookieExpirationDate(30),
            });

            browserLang = helperGetCookie("ig_user_lang");
        } else {
            this.getCurrentLang().then((resp) => {
                const getCurrentLang = resp;

                // console.log(userLang);
                // console.log(getCurrentLang);

                // Compare current lang with browser lang
                if (userLang === getCurrentLang) {
                    // console.log("the same!");
                } else {
                    const newUrl = window.location.origin + "/" + userLang;
                    window.location.href = newUrl;
                }
            });
        }
    }

    getCurrentLang() {
        return fetch(window.global.ajax_url + "?action=GetCurrentLang", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                const currentLang = data.data;

                return currentLang;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    dropdownClick() {
        this.dropdown.addEventListener("click", () => {
            const element = this.dropdown.querySelector(".apw-ig-sub-menu");
            element.classList.toggle("apw-ig-sub-menu-active");
        });
    }

    dropdownModalClick() {
        this.dropdownModal.addEventListener("click", (e) => {
            const element =
                this.dropdownModal.querySelector(".apw-ig-sub-menu");
            element.classList.toggle("apw-ig-sub-menu-active");
        });
    }

    langLinkClick(e) {
        const lang = e.target.getAttribute("lang");

        helperSetCookie("ig_user_lang", lang, {
            expires: helperSetCookieExpirationDate(30),
        });
    }

    closeModalLang() {
        document.body.classList.remove("show-lang-modal");
        this.modal.classList.add("is-hidden");

        this.getCurrentLang().then((resp) => {
            const getCurrentLang = resp;

            helperSetCookie("ig_user_lang", getCurrentLang, {
                expires: helperSetCookieExpirationDate(30),
            });
        });
    }
}
